import React from 'react'
import CardWidget, { Colors } from '../../../../components/CardWidget'
import CardWidgetSkeleton from '../../../../components/skeletons/CardWidgetSkeleton'
import { formatCurrency, formatNumber } from '../../../../utils/Helpers'

type Props = {
  multipleShoppingCartFailedGMV: number,
  multipleShoppingCartFailedQuantity: number
}

const MultipleShoppingCartFailed = ({
  multipleShoppingCartFailedGMV,
  multipleShoppingCartFailedQuantity
}: Props): JSX.Element => {
  if (multipleShoppingCartFailedGMV && !multipleShoppingCartFailedQuantity) return <CardWidgetSkeleton />

  return (
    <CardWidget title={`Pedidos com falha (${formatNumber(multipleShoppingCartFailedQuantity, 0)} itens)`} number={`${formatCurrency(multipleShoppingCartFailedGMV)}`} color={Colors.red} />
  )
}

export default MultipleShoppingCartFailed
